import { genericOptionsDefaults } from '@widgets/GenericBookings/context/Options';
import { createContext } from 'react';
export const optionsDefaults = {
    ...genericOptionsDefaults,
    dayTicketId: 1,
    activities: [],
    priceBands: [],
    isMulti: true,
    isBuilder: false,
};
export const OptionsCTX = createContext(optionsDefaults);
